import React from 'react';
import { ROUTE_EVENTS, ROUTE_POSTER_CHAMPION_SHIP_2023, ROUTE_POSTER_CHAMPION_SHIP_2024 } from '../../routing/Routes';
import { FormattedMessage } from 'react-intl';
import Screen from '../../components/screen/Screen';
import championShip2023Image from './campeonato_autonomico_aire_libre_2023.jpg';
import championShip2024Image from './campeonato_spanya_aire_libre_deportistas_discapacidad_2024.jpeg';
import championShip2025Image from './campeonato_aire_libre_2025.jpeg';
import './events.scss';
import { AppIcon } from '../../Config';

export const EventsView = (
): React.ReactElement => {

    const openPDFInNewTab = async (pdfName: string) => {
        try {
            const response = await fetch(`/${pdfName}.pdf`);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error loading PDF:', error);
        }
    };

    return (
        <Screen currentRoute={ROUTE_EVENTS}>
            <div className="section-container">
                <h2><FormattedMessage id={'events.title'} /></h2>

                <div className={"content events-gap"}>

                    <h3><FormattedMessage id={'events.championship-2025.title'} /></h3>
                    <div className={"championship-description"}>
                        <FormattedMessage id={'events.championship-2025.description'} />
                    </div>

                    <div className="championship-poster">
                        <img
                            className={"poster"}
                            src={championShip2025Image}
                            alt='Campeonato provincias Valencia y Castellón aire libre 2025'
                            onClick={() => window.open(championShip2025Image, '_blank')}
                        />
                        <a href={championShip2025Image}
                            download={"ccampeonato_aire_libre_2025"}
                        >
                            <i className={`${AppIcon.DOWNLOAD} poster-icon`} />
                        </a>
                        <i className={`${AppIcon.FACEBOOK} poster-icon`}
                            onClick={() => window.open('https://www.facebook.com/groups/213420072780647/permalink/1852225985566706/', '_blank')}
                        />
                    </div>
                </div>

                <div className={"content events-gap"}>

                    <h3><FormattedMessage id={'events.championship-2024.title'} /></h3>
                    <div className={"championship-description"}>
                        <FormattedMessage id={'events.championship-2024.description'} />
                    </div>
                    <div className="recommendations-container">
                        <span className="title"><FormattedMessage id={'events.championship-2024.more-information'} />: </span>
                        <div>
                            <FormattedMessage id={'events.championship-2024.accommodation'} />{`: `}                        
                            <span
                                className="downloadable"
                                onClick={() => openPDFInNewTab('alojamiento_recomendado_burriana')}>
                                <FormattedMessage id={'events.championship-2024.download'} />
                            </span>

                        </div>
                        <div>
                            <FormattedMessage id={'events.championship-2024.information'} />{`: `}
                            <span
                                className="downloadable"
                                onClick={() => openPDFInNewTab('circular_informativa')}>
                                <FormattedMessage id={'events.championship-2024.download'} />
                            </span>
                        </div>
                        <div>
                            <FormattedMessage id={'events.championship-2024.direction'} />{`: `}                    
                            <span
                                className="downloadable"
                                onClick={() => window.open('https://maps.app.goo.gl/cq2QWRCxEFTjjPeq7', '_blank')}>
                                <FormattedMessage id={'events.championship-2024.open-maps'} />
                            </span>
                        </div>
                    </div>

                    <div className="championship-poster">
                        <img
                            className={"poster"}
                            src={championShip2024Image}
                            alt='Campeonato de españa al aire libre para deportistas con discapacidad 2024'
                            onClick={() => window.open(ROUTE_POSTER_CHAMPION_SHIP_2024, '_blank')}
                        />
                        <a href={championShip2024Image}
                            download={"campeonato_espanya_aire_libre_deportistas_discapacidad_2024"}
                        >
                            <i className={`${AppIcon.DOWNLOAD} poster-icon`} />
                        </a>
                        <i className={`${AppIcon.FACEBOOK} poster-icon`}
                            onClick={() => window.open('https://www.facebook.com/share/p/b1vCAfhdD8XgxcpT/', '_blank')}
                        />
                    </div>
                </div>

                <div className={"content events-gap"}>

                    <h3><FormattedMessage id={'events.championship-2023.title'} /></h3>
                    <div className={"championship-description"}>
                        <FormattedMessage id={'events.championship-2023.description'} />
                    </div>

                    <div className="championship-poster">
                        <img
                            className={"poster"}
                            src={championShip2023Image}
                            alt='Campeonato autonómico aire libre 2023'
                            onClick={() => window.open(ROUTE_POSTER_CHAMPION_SHIP_2023, '_blank')}
                        />
                        <a href={championShip2023Image}
                            download={"campeonato_autonomico_aire_libre_2023"}
                        >
                            <i className={`${AppIcon.DOWNLOAD} poster-icon`} />
                        </a>
                        <i className={`${AppIcon.FACEBOOK} poster-icon`}
                            onClick={() => window.open('https://www.facebook.com/groups/213420072780647/posts/1411277266328249/', '_blank')}
                        />
                    </div>
                </div>
            </div>
        </Screen>
    )

}